import { defineAction } from '~/prix'
import materialRequestFetchAction from './materialRequestFetch.action.json' with { type: 'json' }
import { materialRequestObject } from '../materialRequestObject'

const materialRequestFetchDefinition = defineAction({
  ...materialRequestFetchAction,
  input: materialRequestObject.pick({ id: true }),
  output: materialRequestObject,
})

export default materialRequestFetchDefinition
